// extracted by mini-css-extract-plugin
module.exports = {"relatedProjectsContainer":"resourcePage_relatedProjectsContainer__DvQic","h2":"resourcePage_h2__lEBrw","centerImage":"resourcePage_centerImage__Q7qkO"};